__turbopack_context__.v({
  "banner_image_block_avanti": "d2MwUa_banner_image_block_avanti",
  "cover_content": "d2MwUa_cover_content",
  "image_block": "d2MwUa_image_block",
  "login_banner": "d2MwUa_login_banner",
  "login_banner_styles": "d2MwUa_login_banner_styles",
  "richtext": "d2MwUa_richtext",
});
